import { useMemo } from "react";
import { assignRef } from "../utils/react-util";
/**
 * Merges multiple refs into a single ref. This will create a new function if the ref props change
 * and are defined. This means react will call the old forkRef with `null` and the new forkRef
 * with the ref. Cleanup naturally emerges from this behavior.
 */
export function useForkRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return useMemo(() => {
    if (refs.every(ref => !ref)) {
      return null;
    }
    return val => {
      refs.forEach(ref => assignRef(ref, val));
    };
  }, refs);
}